import React from "react";
import { Link } from "react-router-dom";
import { Card, Button, Badge } from "@/components/design-system";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen bg-[#E8F1FF] flex items-center justify-center p-6">
      <div className="w-full max-w-lg" data-testid="payment-cancel">
        <Card className="!p-8 text-center">
          <Badge variant="neutral">No charge made</Badge>
          <h1 className="font-[Montserrat] font-extrabold text-3xl text-[#0B1F3A] mt-3">Checkout cancelled</h1>
          <p className="text-[#0B1F3A]/75 mt-2">Come back any time — your seat is waiting.</p>
          <div className="mt-6 flex justify-center gap-3">
            <Link to="/app/billing"><Button variant="primary">Back to plans</Button></Link>
            <Link to="/app"><Button variant="secondary">Dashboard</Button></Link>
          </div>
        </Card>
      </div>
    </div>
  );
}
